import template from './mainRouting.html';
import controller from './mainRouting.controller';
import './mainRouting.scss';

let mainRoutingComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default mainRoutingComponent;



// WEBPACK FOOTER //
// ./client/app/features/mainRouting/mainRouting.component.js